import SportsmanList from "../../../components/dashboard/SportsmanList/SportsmanList";
import styles from "./HomePage.module.styl";
import { Card, Loader } from "uikit/components";
import Heading from "uikit/components/Heading/Heading";
import Button from "uikit/components/Button/Button";
import React, { useEffect, useRef, useState } from "react";
import MainMap from "../../../components/dashboard/MainMap/MainMap";
import MapFilter from "../../../components/dashboard/Filters/MapFilter";
import { useGetSportsmansData, useMapData } from "hooks/map";
import { useLocation } from "react-router-dom";
import {Helmet} from "react-helmet-async";

const defaultFilterState = {
    sportType: null,
    sex: null,
    sportTrainingLevel: null,
    regionId: null,
    schoolId: null,
};

export default function HomePage() {
    const [filters, setFilters] = useState(defaultFilterState);
    const [activeMap, setActiveMap] = useState(true);
    const [selectedRegion, setSelectedRegion] = useState(null);
    const sportTypeRef = useRef();
    const sexRef = useRef();
    const sportLevelRef = useRef();

    const location = useLocation();
    useEffect(() => {
        if (location) {
            if (location.state?.fromSportsmanPage === true) {
                setActiveMap(false);
            }
            window.history.replaceState({}, document.title);
        }
    }, [location]);

    const { isLoading: isSportsmansLoading, data: sportsmans } = useGetSportsmansData(
        filters.sportType,
        filters.sex,
        filters.sportTrainingLevel,
        filters.regionId,
        filters.schoolId,
    );

    const { isLoading: isMapLoading, data: mapData } = useMapData(
        filters.sportType,
        filters.sex,
        filters.sportTrainingLevel,
    );

    const mapClick = function () {
        sportTypeRef.current.state.menuIsOpen = false;
        sexRef.current.state.menuIsOpen = false;
        sportLevelRef.current.state.menuIsOpen = false;
        setActiveMap(true);
        setSelectedRegion(null);
    };

    const listClick = function () {
        sportTypeRef.current.state.menuIsOpen = false;
        sexRef.current.state.menuIsOpen = false;
        sportLevelRef.current.state.menuIsOpen = false;
        setActiveMap(false);
    };

    const onRegionClick = function (regionId) {
        setActiveMap(false);
        setSelectedRegion(regionId);
    };

    const onFilterChange = function (sportType, sex, sportTrainingLevel, regionId, schoolId) {
        setFilters({ sportType, sex, sportTrainingLevel, regionId, schoolId });
    };

    return (
        <>
            <Helmet>
                <title>Атлас спортивной подготовки</title>
            </Helmet>
            <Heading size={"h1"}>Атлас спортивной подготовки</Heading>
            <Card className={styles.container} borderRadius={"giant"} padding={"big"}>
                <div className={styles.header}>
                    <Heading size={"h2"}>
                        {activeMap
                            ? "Мониторинг подготовки спортивного резерва по видам спорта"
                            : "Ведущие спортсмены по результатам тестирования"}
                    </Heading>
                    <div className={styles.buttonPanel}>
                        <Button
                            onClick={mapClick}
                            className={activeMap ? styles.activeButton : styles.deactivateButton}
                        >
                            Карта
                        </Button>
                        <Button
                            onClick={listClick}
                            className={!activeMap ? styles.activeButton : styles.deactivateButton}
                        >
                            Список
                        </Button>
                    </div>
                </div>
                <MapFilter
                    onFilterChange={onFilterChange}
                    exportedRegionId={selectedRegion}
                    isMapView={activeMap}
                    sportTypeSelectRef={sportTypeRef}
                    sexSelectRef={sexRef}
                    sportLevelSelectRef={sportLevelRef}
                />
                {activeMap && (
                    <div>
                        {isMapLoading ? (
                            <Loader size={"full"} />
                        ) : (
                            <div>
                                <MainMap
                                    withoutHighlightRegions={mapData.regionsWithoutTop100}
                                    highlightedRegions={mapData.regionsWithTop100}
                                    onMapRegionClick={onRegionClick}
                                />
                                <div className={styles.legends}>
                                    <div className={styles.legend}>
                                        <div className={styles.block1} />
                                        <div className={styles.name}>
                                            есть спортсмены из топ-100
                                        </div>
                                    </div>
                                    <div className={styles.legend}>
                                        <div className={styles.block2} />
                                        <div className={styles.name}>
                                            нет спортсменов из топ-100
                                        </div>
                                    </div>
                                    <div className={styles.legend}>
                                        <div className={styles.block3} />
                                        <div className={styles.name}>
                                            не проводилось тестирование
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                )}
                {!activeMap && !isSportsmansLoading && (
                    <div>
                        <SportsmanList sportsmans={sportsmans?.items} />
                    </div>
                )}
                {!activeMap && isSportsmansLoading && <Loader size={"full"} />}
            </Card>
        </>
    );
}
